<template>
  <div class="pc-layout__sidebar">
    <avatar/>
    <sidebar-nav/>
    <sidebar-tools/>
  </div>
</template>

<script>
import Avatar from '@/components/avatar/Avatar.vue'
import SidebarNav from '@/components/layouts/sidebar/Nav.vue'
import SidebarTools from '@/components/layouts/sidebar/Tools.vue'

export default {
  components: {
    Avatar,
    SidebarNav,
    SidebarTools
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-layout__sidebar {
  width: $layout-sidebar-width;
  min-width: $layout-sidebar-width;
  border-right: 1px solid $border-color-structure;
  // box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: .8rem 0;

  .icon {
    cursor: pointer;
    width: 4rem;
    height: 4rem;
    font-size: 1.6rem;
    color: $color-main;
    border-radius: 10%;

    & + .icon {
      margin-top: .5rem;
    }
  }
}

.pc-layout__sidebar-icon {
  width: 4rem;
  height: 4rem;
  font-size: 1.8rem;
  color: $color-main;
  border-radius: 10%;

  & + .pc-layout__sidebar-icon {
    margin-top: 1rem;
  }
}

</style>
